




























import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';

@Component
export default class CustomField extends Mixins(CommonMixin) {
  // Props
  @Prop(Boolean) public readonly isReadOnly!: boolean;
  @Prop(Object) public readonly fieldrec!: any;
  public title() {
    if (this.fieldrec) {
      return this.fieldrec.show_text;
    }
  }

  public emitChange() {
    this.$emit('change', this);
  }
  public inputChanged() {
    if (this.fieldrec.value_index === undefined) {
      this.fieldrec.value_index = -1;
      this.fieldrec.value = null;
    } else if (this.fieldrec.value_index === -1 || this.fieldrec.value_index === null) {
      this.fieldrec.value = null;
    } else {
      const items = this.buildOptionList(this.fieldrec.values);
      if (items) {
        this.fieldrec.value = items[this.fieldrec.value_index].text;
      } else {
        this.fieldrec.value = null;
      }
    }
    this.emitChange();
  }
}
